import gsap from "gsap";
//import SpritesheetAnimate from './sprite-animate';
import SpritesheetAnimate from '../utils/spritesheet-animate';
import BaseView from './base-view.js';

class LoaderView extends BaseView {
	//el() { return '#loader'; } // in footer 

	events() { return {}; }

	postInitialize() { return {}; }

	bindings() { return {}; }

	listeners() { return {}; }

	render() {
		const self = this;
		// vars
		this.$html = $('html');
		this.pageLoader = this.model.get('pageLoader');
		this.$loaderDest = $('.loader-dest', this.$el);
		this.loaderShowing = false;

		// register loading sprites
		this.sprites = [
			{
				id: 'trophy',
				img: 'assets/img/sprites/loader-trophy.png',
				el: this.$loaderDest[0],
				displayW: 100, //200
				totalW: 100, //200
				displayH: 75, // 150
				totalH: 5400, //10800
				speed: 0.032, // smaller is faster
				numLoops: 9999,
				retina: true,
			}
			//...
		];
		this.preloadImages = {};
		this.sprites.forEach((tSprite, index) => {
			SpritesheetAnimate.registerSpriteObj(tSprite);
			if (document.images) {
				self.preloadImages['img' + index] = new Image();
				self.preloadImages['img' + index].src = tSprite.img;
			}
		});

		return self;
	}

	showLoader(cb_func) {
		const self = this;
		let backgroundSize = '';
		// kill existing animations
		gsap.killTweensOf(this.$el);
		gsap.killTweensOf(this.$loaderDest);

		// get random bg img
		this.progressSprite = this.sprites[Math.floor(Math.random() * this.sprites.length)];
		if (this.progressSprite.retina) {
			backgroundSize = '' + this.progressSprite.displayW + 'px ' + this.progressSprite.totalH + 'px';
		}
		// populate progress modal img dest
		this.$loaderDest.css({
			backgroundImage: `url(${this.progressSprite.img})`,
			width: this.progressSprite.displayW,
			height: this.progressSprite.displayH,
			backgroundSize: backgroundSize,
		});

		gsap.to(this.$el, {
			duration: 0.4,
			autoAlpha: 1,
			display: 'block',
			ease: 'quad.out',
			onComplete() {
				if (self.pageLoader) {
					self.$html.addClass('loader-show');
				}
				self.loaderShowing = true;
				// start animation
				SpritesheetAnimate.playSprite(self.progressSprite.id, self.$loaderDest[0]);
				// show content
				gsap.to(self.$loaderDest, {
					duration: 0.6,
					autoAlpha: 1,
					ease: 'quad.out',
					onComplete() {
						if (cb_func) {
							cb_func.call(null);
						}
					},
				});
			},
		});
		// fire page load event
		if (this.pageLoader) {
			this.pubSub.trigger('loaderShow');
		}
	}

	closeLoader(cb_func) {
		if (this.pageLoader) {
			// remove class on html for scroller // TODO: THIS IS NEVER ADDED - SHOULD IT BE?
			this.$html.removeClass('loader-show');
		}
		this.loaderShowing = false;

		// kill existing animations
		gsap.killTweensOf(this.$el);
		gsap.killTweensOf(this.$loaderDest);

		// Hide everything
		gsap.to(this.$loaderDest, {
			duration: 0.4,
			autoAlpha: 0.01,
			ease: 'quad.in',
			onComplete() {
				SpritesheetAnimate.resetAllSprites();
			},
		});
		gsap.to(this.$el, {
			duration: 0.4,
			delay: 0.2,
			autoAlpha: 0,
			display: 'none',
			ease: 'quad.in',
			onComplete() {
				if (cb_func) {
					cb_func.call(null);
				}
			},
		});
	}

	cleanup() {
		// clear additional listeners
		this.$el.empty();
	}
}

export default LoaderView;